import React from 'react'
import { useTranslation } from 'react-i18next'
import Icon from 'components/uiElements/Icon'
import KioskIntroPopup from 'components/KioskIntroPopup'
import KioskCompositionSelector from 'components/KioskCompositionSelector'
import { FURNISHED, EMPTY, RoomType } from 'models/kiosk/constants'

require('./styles.scss')

interface KioskLandingProps {
    openComposition: (compositionId: number) => void
    openScene: (sceneId: number) => void
    roomType: RoomType
    selectKioskRoomType: (rt: RoomType) => void
    isKioskIntroViewed: boolean
    setKioskIntroViewed: () => void
}

const KioskLanding = ({ openComposition, openScene, roomType, selectKioskRoomType, isKioskIntroViewed, setKioskIntroViewed }: KioskLandingProps) => {
    const { t } = useTranslation()

    const onRoomClick = (rType: RoomType) => {
        selectKioskRoomType(rType)
    }
    return (
        <div className="KioskLanding">
            <KioskIntroPopup isVisible={!isKioskIntroViewed} closeModal={setKioskIntroViewed} />
            {roomType && (
                <div className="compSelectionModal">
                    <KioskCompositionSelector
                        closeModal={() => selectKioskRoomType(null)}
                        roomType={roomType}
                        openComposition={openComposition}
                        openScene={openScene}
                    />
                </div>
            )}

            {!roomType && (
                <>
                    <div className="pickRoomType" onClick={() => onRoomClick(FURNISHED)}>
                        <img
                            className="roomImage"
                            src={`${ASSET_BUCKET}/kiosk/furnishedSpace.jpg`}
                            alt={t('kiosk.alt.furnished space')}
                        />
                        <section className="textSection">
                            <p className="smallText">{t('kiosk.start with')}</p>
                            <p className="heading">{t('kiosk.furnished space')}</p>
                            <p className="subheading">{t('kiosk.living rooms')}</p>
                            <div className="cta">
                                <div> {t('kiosk.pick a room')}</div>
                                <Icon code="arrowRight" />
                            </div>
                        </section>
                    </div>
                    <div className="pickRoomType" onClick={() => onRoomClick(EMPTY)}>
                        <img
                            className="roomImage"
                            src={`${ASSET_BUCKET}/kiosk/emptyShell.jpg`}
                            alt={t('kiosk.alt.empty shell')}
                        />
                        <section className="textSection">
                            <p className="smallText">{t('kiosk.start with')}</p>
                            <p className="heading">{t('kiosk.an empty shell')}</p>
                            <p className="subheading">{t('kiosk.design your own rooms')}</p>
                            <div className="cta">
                                <div> {t('kiosk.pick a room')}</div>
                                <Icon code="arrowRight" />
                            </div>
                        </section>
                    </div>
                </>
            )}
        </div>
    )
}

export default KioskLanding
